import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  coOpActionCreators,
  CoOpActionKeys,
  FetchCoOpRequestStatuses,
  ICoOpRequestStatus
  } from '..';
import { uiActionCreators } from '../../ui';

function* fetchCoOpRequestStatusesSaga(action: FetchCoOpRequestStatuses) {
  yield put(uiActionCreators.toggleLoading('coOpRequestStatuses'));
  const statuses: ICoOpRequestStatus[] = yield call(api.fetchCoOpRequestStatuses, action.payload.coOpRequestId);

  yield put(coOpActionCreators.setRequestStatuses({ coOpRequestId: action.payload.coOpRequestId, statuses }));
  yield put(uiActionCreators.toggleLoading('coOpRequestStatuses'));
}

export function* watchFetchCoOpRequestStatuses() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_REQUEST_STATUSES, fetchCoOpRequestStatusesSaga);
}
